/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const FlashAutoIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Flash Auto',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M6.001 2h14l-8 12h10l-19.1 22h-.9l6-16H.251l5.75-18zM28.418 16.417c-.026-.134-.054-.161-.189-.161h-3.754c-.107 0-.161.081-.161.189a4.132 4.132 0 0 1-.244 1.455l-5.563 15.83c-.028.189.026.27.189.27h2.7a.267.267 0 0 0 .3-.216L22.954 30h6.913l1.333 3.838a.272.272 0 0 0 .271.162H34.5c.161 0 .189-.081.161-.243Zm-2.052 2.54h.026c.541 1.89 2.1 6.481 2.664 8.264h-5.3c.813-2.457 2.178-6.455 2.61-8.264Z"
    />
  </svg>`;
};
